import { gql } from "@apollo/client";

export const NOTIFICATION_MARKED_AS_READ = gql`
  subscription notificationMarkedAsRead {
    notificationMarkedAsRead {
      notificationId
    }
  }
`;

export const NOTIFICATION_DISMISSED = gql`
  subscription notificationDismissed {
    notificationDismissed {
      notificationId
    }
  }
`;

export const ALL_NOTIFICATIONS_DISMISSED = gql`
  subscription notificationsAllDismissed {
    notificationsAllDismissed
  }
`;

export const NOTIFICATION_SENT = gql`
  subscription notificationSent {
    notificationSent {
      notificationId
      notificationBody
      notificationTitle
      sourceContextKeys {
        documentId
        siteId
      }
      sourceContextName
      isRead
      deliverymethod
    }
  }
`;
